var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"raw-data bg-black p-2 m-2"},[_c('vue-json-pretty',{attrs:{"deep":3,"showLength":true,"data":_vm.json}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }